import React, { Component } from 'react';
import $ from 'jquery';
import * as Reqst from '../../../utils/Reqst';
import Sanitize from '../../../utils/Sanitize';
import {notify} from 'react-notify-toast';
import {Row,Col} from 'react-bootstrap';


class Add extends Component{
	constructor(props){
		super(props);
		this.state = {
			loginId: Sanitize.getData('labUser_id'),
			companyId: Sanitize.getData('labUser_clientid'),
			masterId: Sanitize.getData('labUser_masterid'),
			saveText: 'SAVE SUBJECT',
			isRedirect: false,
			showLoader: false,
			showAddModal: false,
		}
		
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
	}
	
	handleFormSubmit(e){
		e.preventDefault();
		this.setState({showLoader:true,saveText:'Saving..'});
		var formData = Sanitize.objectifyForm($("#frmAdd").serializeArray());
		Reqst.axPost('subject/savesubject',{token: Reqst.Token(formData)}).then(res=>{
			if(res['data'].status=='1')
			{
				document.getElementById("frmAdd").reset();
				notify.show(res['data'].msg,'success');
				this.setState({showLoader:false,saveText:'SAVE SUBJECT'});
				if(this.props.afterFinish) this.props.afterFinish();
			}
			else
			{
				notify.show(res['data'].msg,'error');
				this.setState({showLoader:false,saveText:'SAVE SUBJECT'});
			}
		});
	}
	
	render(){
		
		return(
			<div>			
				<form action="" method="post" encType="multipart/form-data" id="frmAdd" onSubmit={this.handleFormSubmit} >
					<input type="hidden" name="i__lid" value={this.state.loginId} />
					<input type="hidden" name="i__company" value={this.state.companyId} />
					<input type="hidden" name="i__master" value={this.state.masterId} />
					<Row>
						<Col md={12} >
							<label>Type <span className="text-danger">*</span></label>
							<select name="i__type" id="i__type" className="form-control input-sm" required>
								<option value="">Select Type</option>
								<option value="ug">UG</option>
								<option value="pg">PG</option>
							</select>
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>Subject Code </label>
							<input type="text" name="i__code" id="i__code" className="form-control input-sm" />
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>Subject Name <span className="text-danger">*</span></label>
							<input type="text" name="i__name" id="i__name" className="form-control input-sm" required />
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<label>Active Status <span className="text-danger">*</span></label>
							<select name="i__status" id="i__status" className="form-control input-sm" required >
								<option value="1"> Active </option>
								<option value="0"> In Active </option>
							</select>
						</Col>
					</Row>
					<Row>
						<Col md={12} >
							<br />
							<div className="text-right" >
								<button type="submit" className="btn btn-info btn-sm btn-success_2" disabled={this.state.saveText!='SAVE SUBJECT'} >
									<i className="fa fa-check"></i> {this.state.saveText} 
								</button>
							</div>
						</Col>
					</Row>
				</form>
			</div>
		);
	}
	
}
export default Add;